import {getWindowWidth} from "../../dev/js/core/Helpers/Helpers";
//import {debounce} from 'lodash';
import onMobileImageReplace from './mobileImageReplace';
import Video from '../../components/video/video';


const vilpe = () => {
    
    
    const accordions = () => {
        let accordions = document.querySelectorAll('.js-accordion-title');
        
        [...accordions].forEach(accordion => {
            accordion.addEventListener('click', e => {
                accordion.classList.toggle('active');
                $(e.currentTarget.nextElementSibling).slideToggle();
            });
        });
    };
    
    const nTabs = () => {
        
        const classes = {
            header : '.ntabs-header',
            changer : '.ntab-changer',
            content : '.ntab-content'
        };
        
        let state = {};
        
        const headers = document.querySelectorAll(classes.header);
    
        const setActive = elem => !elem.classList.contains('active') ? elem.classList.add('active') : null;
    
        const setInactive = elem => elem.classList.remove('active');
    
        const setActiveChanger = currentInstance => {
            state[currentInstance].changers.forEach((changer, index) => index === state[currentInstance].ind ? setActive(changer) : setInactive(changer));
        };
        
        const setActiveContent = currentInstance => {
            const contents = [...state[currentInstance].content.querySelectorAll(classes.content)];
    
            contents.forEach((content, index) => index === state[currentInstance].ind ? setActive(content) : setInactive(content));
        };
        
        const activate = index => {
            setActiveChanger(index);
            setActiveContent(index);
        };
        
        if (headers){
            [...headers].forEach((header, index) => {
                state[index] = {
                    content : document.querySelector(header.dataset.tabs),
                    changers : [...header.querySelectorAll(classes.changer)],
                    ind : null
                };
                
                state[index].changers.forEach((changer,ind) => {
                    changer.addEventListener('click', e => {
                        state[index].ind = ind;
                        !e.currentTarget.classList.contains('active') ?
                            activate(index): null;
                    });
                });
            });
        }
        
    };
    
   const clickAndScrollTo = (clickElement, scrollTarget) => {
        document.getElementById(clickElement).addEventListener('click', e => {
            e.preventDefault();
            document.getElementById(scrollTarget).scrollIntoView({behavior : "smooth"});
        });
    };
    
    nTabs();
    accordions();
   // onMobileImageReplace();
    
    clickAndScrollTo('js-check-btn', 'js-faq');
    clickAndScrollTo('js-check-hoods', 'js-hoods');
    
};

export default vilpe;


// WEBPACK FOOTER //
// ../containers/vilpe/vilpe.js